<asl-google-signin-button
  type="standard"
  size="large"
  logo_alignment="center"
  [width]="width"
></asl-google-signin-button>
